import { render, staticRenderFns } from "./motionCustomerData.vue?vue&type=template&id=053e4994&scoped=true&"
import script from "./motionCustomerData.vue?vue&type=script&lang=js&"
export * from "./motionCustomerData.vue?vue&type=script&lang=js&"
import style0 from "./motionCustomerData.vue?vue&type=style&index=0&id=053e4994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053e4994",
  null
  
)

export default component.exports